<app-loader [isLoading]="isLoading"></app-loader>

<div class="merge-container">
  <div class="d-flex justify-content-between">
    <span class="heading-text">Merge FC</span>
    <button class="img-button dp-secondary-btn" (click)="onMergeHistory()">
      <img src="../../assets/images/merge-history.svg" alt="mergeFc" />
      <span class="btn-txt">Merge history</span>
    </button>
  </div>

  <form class="input-div" (ngSubmit)="onClick()">
    <input
      type="tel"
      class="dp-input-control input-content"
      placeholder="Enter Serial No."
      [formControl]="searchReq"
      (keydown)="restrictSLInput($event)"
      [maxlength]="10"
    />
  </form>
  @if(resData===null){
  <div class="search-img">
    <img src="../../assets/images/merge-search.svg" />
    <span class="search-text"
      >Search for a serial number that you wish to merge family codes for</span
    >
  </div>
  } @if(resData!=null){
  <div class="content-div d-flex flex-column">
    <div class="details d-flex justify-content-between">
      <span class="detail-heading"> Serial No.</span>
      <span class="sl-text">{{ searchReq.value }}</span>
    </div>
    <div class="details d-flex justify-content-between">
      <span class="detail-heading"> Name</span>
      <span class="detail-text">{{ resData.mem_full_name }}</span>
    </div>
    <div class="details d-flex justify-content-between">
      <span class="detail-heading">Philanthropy Name</span>
      <span class="detail-text"
        >{{ resData.phl_mem_name }}&nbsp;{{ resData.phl_mem_surname }}</span
      >
    </div>
    <div class="details d-flex justify-content-between">
      <span class="detail-heading">Guardian Name</span>
      <span class="detail-text">{{ resData.mem_guardian_name }}</span>
    </div>
    <div class="details d-flex justify-content-between">
      <span class="detail-heading"> Ritwik Name</span>
      <span class="detail-text">{{ resData.mem_ritwiki_name }}</span>
    </div>
    <div class="details d-flex justify-content-between">
      <span class="detail-heading"> Last Istavrity Date</span>
      <span class="detail-text">{{ resData.last_istavrity_date }}</span>
    </div>
    <!-- <div class="details d-flex justify-content-between">
      <span class="detail-heading">Primary Family Code</span>
      <span class="detail-text">{{ primaryFC[0] }}</span>
    </div> -->
    <!-- @if(secondaryFC.length!=0){ -->
    <div class="details d-flex justify-content-between">
      <span class="detail-heading">Family Code</span>

      <span class="detail-text">{{ resData.mem_family_code }}</span>
    </div>

    <div class="details d-flex justify-content-between">
      <span class="detail-heading"> Address</span>
      <span class="detail-text">{{ resData.address }}</span>
    </div>
    <button class="dp-primary-btn img-button" (click)="onMergeClick()">
      Start Merging
    </button>
  </div>
  }
</div>
